import React from 'react'
import { alertClasses } from '@mui/material'
import { AlertGroupItem, AlertGroupProps } from '@app/components/ui/containers/AlertGroup'
import { ReviewIconBase } from '@app/components/ui/icons/ReviewIcon/ReviewIconBase'
import { ContentLabel, PercentageLabel, StyledAlertGroup, StyledAlertIcon } from './styles'
import { percentageFormatter } from '@app/helpers'
import { FeedbackItem, FeedbackItemMessage } from '@app/types'

export type ItemFeedbackGroupProps = {
  size?: AlertGroupProps['size']
  items?: FeedbackItem[]
  className?: string
  percentageFormatter?: (value: number) => string
  hidePercentages?: boolean
}

type ItemFeedbackGroupMessageProps = FeedbackItemMessage & {
  percentageFormatter: (value: number) => string
  hidePercentages?: boolean
}

const defaultPercentageFormatter = (percentage: number) => percentageFormatter.format(percentage)

const ItemFeedbackGroupMessage: React.FC<ItemFeedbackGroupMessageProps> = ({
  percentage,
  content,
  percentageFormatter,
  hidePercentages,
}) => {
  return (
    <>
      {percentage !== undefined && !hidePercentages && (
        <PercentageLabel component='span'>{percentageFormatter(percentage)}</PercentageLabel>
      )}
      <ContentLabel component='span'>{content}</ContentLabel>
    </>
  )
}

export const ItemFeedbackGroup: React.FC<ItemFeedbackGroupProps> = ({
  size,
  items = [],
  className,
  percentageFormatter = defaultPercentageFormatter,
  hidePercentages = false,
}) => {
  const alertItems: AlertGroupItem[] = items.map(item => ({
    key: item.key,
    severity: item.correct ? 'success' : 'warning',
    icon: false,
    message: item.messages.map((message, index) => (
      <React.Fragment key={message.key}>
        {index === 0 && (
          <StyledAlertIcon className={alertClasses.icon} messagesCount={item.messages?.length}>
            <ReviewIconBase correct={item.correct} />
          </StyledAlertIcon>
        )}
        <ItemFeedbackGroupMessage {...message} percentageFormatter={percentageFormatter} hidePercentages={hidePercentages} />
      </React.Fragment>
    )),
  }))

  return (
    <StyledAlertGroup
      severity='info'
      variant='outlined'
      size={size}
      items={alertItems}
      className={className}
    />
  )
}
